// Card Component

import React from 'react';

const Card = ({ children, className = '', title = '', subtitle = '', action = null, ...props }) => {
  return (
    <div
      className={`bg-white rounded-2xl border border-slate-200/80 shadow-sm hover:shadow-md transition-shadow duration-300 ${className}`}
      {...props}
    >
      {(title || action) && (
        <div className="flex items-center justify-between px-6 pt-5 pb-0">
          <div>
            {title && <h3 className="text-base font-semibold text-slate-800">{title}</h3>}
            {subtitle && <p className="text-xs text-slate-400 mt-0.5">{subtitle}</p>}
          </div>
          {action && <div>{action}</div>}
        </div>
      )}
      <div className={title ? 'p-6 pt-4' : 'p-6'}>
        {children}
      </div>
    </div>
  );
};

export default Card;
